<template>
	<sf-data-table
		ref="varTable"
		paging
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		selection
		:columns="powTourPrvsMngManagementCols_"
		:rows="powTourPrvsMngManagements"
		:excel="isButton_(scrId, 'EX')"
		:addRowDatas="addRowDatas"
		:stripe="false"
		:customExcel="excelFunc"
		@changedPage="changedPage"
		@row-click="rowClick"
	>
		<template v-slot:actionsLeft>
			<!-- 추가 -->
			<sf-button v-if="isButton_(scrId, 'AD')" line icon="square-plue" :onClick="addAction">
				{{ getMessage_('QWCC001488') }}
			</sf-button>
			<!-- 저장 -->
			<sf-button v-if="isButton_(scrId, 'CU') && showSaveBtn" line icon="file" :onClick="saveAction">
				{{ getMessage_('MWCC000327') }}
			</sf-button>
			<!-- 삭제 -->
			<sf-button color="error" line v-if="isButton_(scrId, 'CD')" icon="trash" :onClick="deleteAction">
				{{ getMessage_('QWCC001136') }}
			</sf-button>
		</template>
		<template v-slot:actionsRight>
			<!-- 엑셀템플릿 다운 -->
			<sf-button v-if="isButton_(scrId, 'EU')" line icon="file" :onClick="downExcelTemp">
				{{ getMessage_('QWCC001799') }}
			</sf-button>
			<!-- 엑셀업로드 -->
			<sf-button v-if="isButton_(scrId, 'EU')" line icon="excel" :onClick="openModal">
				{{ getMessage_('QWCC000927') }}
			</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourPrvsMng/store/helpers';
import * as yup from 'yup';
import gqmsUtils from '@/qmsUtils';
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			addRowDatas: []
		};
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		openModal() {
			// 엑셀업로드팝업 호출
			const param = {
				title: this.getMessage_('QWCC001475'), //타이틀바 값 [공정순회 항목 엑셀 업로드]
				apiGubun: 'POW_TOUR_PRVS_MNG', //업무구분값
				flag: 'I' //INSERT는 i Update U로 만듬
			};
			this.$emit('PopupOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		resetTable() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		},
		addAction() {
			if (this.isOldRow && this.hasChanged_) {
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001511'), //작성된 내용은 사라집니다. 계속 하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001969'), clickFn: this.initRowAction }] //진행할 경우
				});
			} else this.initRowAction();
		},
		initRowAction() {
			this.setState_({ key: 'isOldRow', value: false });
			this.setState_({ key: 'powPrvsCdList', value: [] });
			this.setSelectedRowInit_();
		},
		saveAction() {
			//저장(폼)
			const saveListRows = this.selectedRow;
			try {
				//벨리데이션체크
				this.insVali.validateSync(saveListRows);
				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: () => this.save(saveListRows) }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		deleteAction() {
			const selected = this.$refs.varTable.getSelectedRows();
			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			let delValiGb = false;
			this.$refs.varTable.multipleSelection.forEach(row => {
				if (row.tableState === 'I') {
					delValiGb = true;
				}
			});
			try {
				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000107'), clickFn: () => this.remove(selected) }] //삭제
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
				return false;
			}
		},
		resetSelection() {
			const checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}

			this.$emit('Refresh');
		},
		async save(saveRows) {
			try {
				this.$sf_toggleLoading(true);
				const response = await this.setPowTourPrvsMngManagement_({ status: 1, data: saveRows });
				this.$sf_toast({
					type: response.code === 0 ? 'ok' : 'error',
					message: this.getMessage_(response.messageCd)
				});
				response.code === 0 && this.setSelectedRowInit_();
				this.resetTable();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async remove(selected) {
			this.$sf_toggleLoading(true);
			try {
				const response = await this.setPowTourPrvsMngManagement_({ status: 3, data: selected });
				this.$sf_toast({
					type: response.code === 0 ? 'ok' : 'error',
					message: this.getMessage_(response.messageCd)
				});
				response.code === 0 && this.resetTable();
				this.resetSelection();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		rowChange(row) {
			this.setState_({ key: 'isOldRow', value: true });
			this.setState_({ key: 'selectedRow', value: { ...row } });
			this.setState_({ key: 'oldSelectedRow', value: { ...row } });
		},
		rowClick(row) {
			if (this.isOldRow && this.hasChanged_) {
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001511'), //작성된 내용은 사라집니다. 계속 하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001969'), clickFn: () => this.rowChange(row) }] //진행할 경우
				});
			} else {
				this.rowChange(row);
			}
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			const queryStr = objectToQuerystring({ powLnCd: this.searchParams.powLnCd });
			const url = `${BASE_URL}/pqy/ptin/powTourPrvsMng/v1/powTourPrvsMngs/excel${queryStr}`;
			const params = { url, columns: this.powTourPrvsMngExcelCols_ };

			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			});
		},
		async downExcelTemp() {
			try {
				this.$sf_toggleLoading(true);
				await this.excelTempDown_({ apiGubun: 'POW_TOUR_PRVS_MNG' });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			return yup.object().shape({
				powLnCd: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001137')])),
				powPrvsCd: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001030')])),
				insnWayCd: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001213')])),
				insnPrvsSbc: yup
					.string()
					.test(
						'max',
						this.$sf_formatString(this.getMessage_('QWCC001739'), [this.getMessage_('QWCC001215'), '66', '200']),
						value => !(gqmsUtils.getHanBytes(value) > 200)
					)
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001215')])),
				insnCyclCd: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001216')])),
				vbgStrtDd: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000920')])),
				useYn: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('MWCC000891')]))
			});
		},
		showSaveBtn() {
			if (this.isOldRow === '') return false;
			return this.hasChanged_;
		}
	}
};
</script>

<style></style>
